const Zoom = ({ color = "#015C9A" }) => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 2C9.33333 1.63181 9.03486 1.33333 8.66667 1.33333H2C1.63181 1.33333 1.33333 1.63181 1.33333 2V7.33333C1.33333 7.70152 1.63181 8 2 8H8.66667C9.03486 8 9.33333 7.70152 9.33333 7.33333V2ZM10.6667 4.04883V4.97656L13.3333 6.75456V2.49349L10.6667 4.04883ZM10.6667 2.50586L13.1628 1.04948L13.2799 0.990885C13.4009 0.940155 13.5314 0.91386 13.6634 0.913411L13.7943 0.921224C13.881 0.932384 13.966 0.955023 14.0469 0.988281L14.1647 1.04622L14.2741 1.11914C14.3435 1.17224 14.4057 1.23413 14.459 1.30339L14.5319 1.41276L14.5905 1.52995C14.6408 1.65108 14.6667 1.78141 14.6667 1.91341V7.3776L14.6576 7.51237C14.6393 7.64586 14.5945 7.77491 14.5247 7.89128C14.4318 8.0464 14.2981 8.17309 14.1387 8.25846C13.9793 8.3438 13.7997 8.38489 13.6191 8.3763C13.4385 8.36766 13.2632 8.30985 13.1126 8.20963H13.112L10.6667 6.57878V7.33333C10.6667 8.4379 9.77124 9.33333 8.66667 9.33333H2C0.89543 9.33333 0 8.4379 0 7.33333V2C0 0.89543 0.895431 0 2 0H8.66667C9.77124 0 10.6667 0.89543 10.6667 2V2.50586Z"
        fill={color}
      />
    </svg>
  );
};

export default Zoom;
